import { useTranslation } from 'react-i18next';

import { formatCurrency } from 'support/helpers/currency/currency';

type TotalProps = {
  amount: number;
  currency: string | undefined;
};

export function Total({ amount, currency }: TotalProps) {
  const { t } = useTranslation();

  return (
    <dl className="flex items-center justify-between pt-6">
      <dt className="text-xs leading-4 font-normal text-gray-500">{t('orderForms:checkout.totalAmount')}</dt>
      <dd className="text-base leading-6 font-bold text-gray-900">{formatCurrency(amount, currency)}</dd>
    </dl>
  );
}
